import axios from 'axios';

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  // Do something with response error
  if (error.response) {
    return Promise.reject(error.response.data);
  }

  return Promise.reject(error.message);
});

export default API_URL;